<template>
  <b-container id="app">
    <b-row>
      <b-col>
        <headerNavbar/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <router-view/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <footerNavbar/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios'
import HeaderNavbar from '@/components/HeaderNavbar'
import FooterNavbar from '@/components/FooterNavbar'
import { AUTH_LOGOUT } from '@/store/actions/auth'

export default {
    name: 'App',
    created: function () {
      axios.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if(typeof err.status !== "undefined") {
            console.log("Response-Status: " + err.status);
          }

          if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            // if you ever get an unauthorized, logout the user
            this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/'))
          }
          throw err;
        });
      });
    },
    components: {
        HeaderNavbar,
        FooterNavbar
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}
#nav a.router-link-exact-active {
  color: #0865cf;
}
.bg-primary {
    background-color: darkred !important;
}

</style>